/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeviceResponseDeviceGroupHistoryElement
 */
export interface ReportForDeviceResponseDeviceGroupHistoryElement {
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceResponseDeviceGroupHistoryElement
     */
    date: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseDeviceGroupHistoryElement
     */
    oldGroupId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseDeviceGroupHistoryElement
     */
    oldGroupName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseDeviceGroupHistoryElement
     */
    newGroupId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseDeviceGroupHistoryElement
     */
    newGroupName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeviceResponseDeviceGroupHistoryElement
     */
    userName: string | null;
}

export function ReportForDeviceResponseDeviceGroupHistoryElementFromJSON(json: any): ReportForDeviceResponseDeviceGroupHistoryElement {
    return ReportForDeviceResponseDeviceGroupHistoryElementFromJSONTyped(json, false);
}

export function ReportForDeviceResponseDeviceGroupHistoryElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseDeviceGroupHistoryElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (json['date'] === null ? null : new Date(json['date'])),
        'oldGroupId': json['oldGroupId'],
        'oldGroupName': json['oldGroupName'],
        'newGroupId': json['newGroupId'],
        'newGroupName': json['newGroupName'],
        'userName': json['userName'],
    };
}

export function ReportForDeviceResponseDeviceGroupHistoryElementToJSON(value?: ReportForDeviceResponseDeviceGroupHistoryElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date === null ? null : value.date.toISOString()),
        'oldGroupId': value.oldGroupId,
        'oldGroupName': value.oldGroupName,
        'newGroupId': value.newGroupId,
        'newGroupName': value.newGroupName,
        'userName': value.userName,
    };
}

